export default __webpack_public_path__ + "static/media/alert-error.905c6ebc.svg";